@use "@fukuri-admins/ui/layout" as *;

.screen {
  @include screen;
}

.content {
  @include content;
  display: flex;
  flex-direction: column;
  height: 100dvh;
}

.body {
  @include body;
}
